import { decode } from 'html-entities';
import parse from 'html-react-parser';
import type { AppNode } from '../types';
import type { Lang } from '../constants';
import { t } from '../i18n';
import { AppCard } from './AppCard';
import { LoadingSpinner } from './LoadingSpinner';
import './ResultsGrid.css';

interface ResultsGridProps {
  lang: Lang;
  apps: AppNode[];
  loading: boolean;
  total: number;
  noResultsHtml?: string;
}

export function ResultsGrid({
  lang,
  apps,
  loading,
  total,
  noResultsHtml,
}: ResultsGridProps) {
  const strings = t(lang);

  if (loading && apps.length === 0) {
    return <LoadingSpinner lang={lang} />;
  }

  if (!loading && apps.length === 0) {
    return (
      <div className="app-library-search__results app-library-search__results--no-results">
        <div className="app-library-search__results-container">
          <div className="ds-content ds-content--m-evo">
            {noResultsHtml ? parse(decode(noResultsHtml)) : <p>{strings.noResults}</p>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-library-search__results">
      <div className="app-library-search__results-container">
        <div aria-live="polite" aria-atomic="true" className="ds-u-visibility--screen-reader" data-current-count={ apps.length } data-total-count={ total }>
          {strings.resultsCount(apps.length, total)}
        </div>
        <div className="ds-l-row app-library-search__results-row">
          {apps.map((app) => (
            <div key={app.nid} className="ds-l-col--12 ds-l-md-col--6 ds-u-display--flex app-library-search__results-column">
              <AppCard app={app} lang={lang} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
